import classNames from 'classnames';
import React from 'react'
import styled from 'styled-components';
import { greyColor, primaryFont, wMedium, primaryColor } from '../../../Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .tab {
    padding: 8px 16px;
    border-radius: 6px;
    border: 1px solid #DADADA;
    background: #FFF;
    cursor: pointer;
    color: ${greyColor};
    font-family: ${primaryFont};
    font-size: 12px;
    font-weight: ${wMedium};
    line-height: 16px;
    letter-spacing: -0.4px;
  }

  .tab.active {
    background: #DDF6E5;
    color: ${primaryColor};
    border-color: ${primaryColor};
  }
`;
type Props = {
  tabs: string[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
};
const defaultProps = {
  tabs: [],
  activeTab: '',
}
const ClusterTabs = function ClusterTabs(props: Props) {
  const { tabs, activeTab, setActiveTab, scrollContainerRef } = props;

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    if (scrollContainerRef?.current) {
      // The page scrolls on the window (the section wrapper is not a scroll
      // container), so scroll the window to the top of the section while
      // accounting for the sticky app header height.
      const headerOffset = window.innerWidth <= 1023 ? 65 : 80;
      const sectionTop = scrollContainerRef.current.getBoundingClientRect().top
        + window.scrollY - headerOffset;
      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth',
      });
    }
  }
  return (
    <Wrapper className='cluster-tabs'>
      {tabs.map((tab) => (
        <div
          key={tab}
          role="button"
          tabIndex={0}
          className={classNames('tab', {
            active: activeTab === tab,
          })}
          onClick={() => handleTabClick(tab)}
        >
          {tab}
        </div>
      ))}
    </Wrapper>
  );
};

ClusterTabs.defaultProps = defaultProps;
export default ClusterTabs;
